<template>
  <FriedDropdown
    :main-axis-offset="8"
    :cross-axis-offset="0"
    :placement="Placement.BottomEnd"
    class="action-button"
  >
    <template #trigger>
      <div :class="['status-dropdown', { completed }]">
        <FriedH5 class="status-text">{{ buttonText }}</FriedH5>
        <FriedIcon :size="IconSize.Small" icon="chevron-down" />
      </div>
    </template>
    <template #content>
      <FriedDropdownItem
        :data-external="`edit-task-drawer-${status}-button`"
        @click="$emit('set-status', completed ? TaskStatus.Incomplete : TaskStatus.Completed)"
      >
        {{ optionText }}
      </FriedDropdownItem>
    </template>
  </FriedDropdown>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { IconSize, Placement } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import { TaskStatus } from '../types/enums/task-status';

export default defineComponent({
  props: {
    status: {
      type: String as PropType<TaskStatus>,
      required: true,
    },
  },
  emits: ['set-status'],
  setup(props) {
    const { t } = useI18n();
    const completed = computed(() => props.status === TaskStatus.Completed);
    const buttonText = computed(() => (completed.value ? t('completed') : t('MAP_not_completed')));
    const optionText = computed(() =>
      completed.value ? t('MAP_dropdown_set_as_uncompleted') : t('map_dropdown_set_as_completed')
    );
    return {
      completed,
      buttonText,
      optionText,
      TaskStatus,
      IconSize,
      Placement,
    };
  },
});
</script>
<style lang="scss" scoped>
.action-button {
  width: fit-content;
}

.status-dropdown {
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--spacing-25);
  padding: var(--spacing-25) var(--spacing-50);
  border-radius: $radius-small;
  width: fit-content;
  max-width: 100%;
  font-weight: 600;
  text-align: center;
  background: var(--error-light);
  color: var(--error-dark);
  cursor: pointer;

  .status-text {
    color: var(--error-dark);
  }

  &.completed {
    background: var(--green-95);
    color: var(--green-25);

    .status-text {
      color: var(--green-25);
    }
  }
}
</style>
